<template>
  <div>
    <abstract/>

    <scenario :show="scenarioShow"/>

    <illustration :show="illustrationShow"/>
  </div>
</template>

<script>
import windowSizeMixin from '../../../mixin/windowSizeMixin'

import Abstract from './Abstract.vue'
import Illustration from './Illustration.vue'
import Scenario from './Scenario.vue'

export default {
  mixins: [ windowSizeMixin ],
  created: function(){
    window.addEventListener("scroll", this.handleScroll);
  },
  components: {
    Abstract,
    Illustration,
    Scenario
  },
  data: ()=>({
    illustrationShow: false,
    scenarioShow: false,
  }),
  destroyed: function(){
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll: function(){
      if(!this.scenarioShow){
        this.scenarioShow = window.scrollY > this.height*0.5;
      }
      if(!this.illustrationShow){
        this.illustrationShow = window.scrollY > this.height*3.7;
      }
    },
  },
}
</script>